import CreateWindow from "../puzzleWindow";
import "swiper/css/swiper.min.css"
import "./index.css";
import { html, render } from "lit-html";
import Swiper from "swiper";
import images from '*.jpg';
import {userChoiceTracker} from "~/src/helpers/userChoiceTracker"
import {tips } from "~/src/tips"
import { exitButtonPosition } from "../../helpers/exitButtonPosition";

const Slide = (url, name) => html`
<div class="swiper-slide">
<div><img src=${url} /></div>
<div class="kuvateksti">${name}</div>
</div>
`
const FlatPuzzle = function (exitcb) {
  const markup = html`
    <div id="parentCameraWrapper">
      <div class="swiper-container">
        <div class="swiper-wrapper">
      ${Object.keys(images).map(e=> Slide(images[e], e) )}
        </div>
        <!-- Add Arrows -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
  `;

  // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
  const puzzleWindow = CreateWindow({exitCallback: exitcb}).element;
  render(markup, puzzleWindow);

  var swiper = new Swiper(".swiper-container", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      slideChange: () => {
          window.scene.getSoundByName("cameraBrowsing")?.play();
      }
    }

  });

  exitButtonPosition()

};

export default FlatPuzzle;
